<template>
  <div>
    <h2>Projekte</h2>
    <p>
      Willkommen zu Ihren Maßnahmen. Diese Seite zeigt die Maßnahmen des Projekts, geordnet nach
      Maßnahmengruppen; Maßnahmen ohne Gruppe erscheinen im Bereich „ohne Zuordnung“. Klicken Sie
      auf eine Maßnahme, um sie zu öffnen und zu bearbeiten. Über das Optionen-Menü (Symbol mit drei
      Punkten) verwalten Sie einzelne Maßnahmen und Gruppen. Neue Maßnahmen und Gruppen legen Sie über
      die Schaltflächen unten an. Wählen Sie mit den Kontrollkästchen aus, welche Maßnahmen und Gruppen
      in die Analyse einbezogen werden sollen.
    </p>
    <p>
      Oben rechts auf der Seite starten Sie die Analyse der ausgewählten Maßnahmen.
      Unten auf der Seite können Sie die Projektdetails bearbeiten oder das Projekt löschen.
    </p>
    <p>Folgende Funktionen sind hier vorhanden:</p>
    <ul>
      <li>
        Maßnahmen und Maßnahmengruppen verwalten.
      </li>
      <li>
        Maßnahmen bzw. Gruppen für das Einsparpotential auswählen und Analyse starten.
      </li>
      <li>
        Projektdetails bearbeiten.
      </li>
      <li>
        Aktuelles Projekt löschen.
      </li>
    </ul>

    <v-expansion-panels accordion class="mt-5">
      <v-expansion-panel>
        <v-expansion-panel-title>
          <div class="heading">Zusätzliche Informationen</div>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <h3>Tabelle &amp; Entwürfe</h3>
            <p>
              Die Tabelle zeigt zu jeder Maßnahme die Spalten Gruppe, Name, Methode, Methode Typ und
              Optionen. Ein Klick auf eine Zeile öffnet die Maßnahme zur Bearbeitung. Eine noch
              unvollständig konfigurierte Maßnahme ist mit dem Zusatz „(Entwurf)“ gekennzeichnet.
            </p>

          <h3>Maßnahmengruppen</h3>
            <p>
              Maßnahmen können in Gruppen organisiert werden. Über die Gruppenüberschrift und das
              Optionen-Menü der Gruppe stehen folgende Funktionen zur Verfügung:
            </p>
            <dl>
              <dt><strong>Gruppe hinzufügen:</strong></dt>
              <dd>
                Legt eine neue Maßnahmengruppe an (unten über die Schaltfläche). Der Name muss eindeutig sein.
              </dd>
              <dt><strong>Umbenennen:</strong></dt>
              <dd>
                Ändert den Namen der Gruppe.
              </dd>
              <dt><strong>Kopie erstellen:</strong></dt>
              <dd>
                Dupliziert die Gruppe einschließlich der enthaltenen Maßnahmen.
              </dd>
              <dt><strong>Gruppe löschen:</strong></dt>
              <dd>
                Löscht die Gruppe. Hinweis: Dabei werden auch alle in der Gruppe enthaltenen
                Maßnahmen aus dem Projekt gelöscht.
              </dd>
            </dl>

          <h3>Maßnahmen verwalten</h3>
            <p>
              Über das Optionen-Menü einer Maßnahme (Symbol mit drei Punkten) verwalten Sie die
              einzelne Maßnahme:
            </p>
            <dl>
              <dt><strong>Umbenennen:</strong></dt>
              <dd>
                Ändert den Namen der Maßnahme.
              </dd>
              <dt><strong>Kopie erstellen:</strong></dt>
              <dd>
                Legt eine Kopie der Maßnahme an.
              </dd>
              <dt><strong>Gruppe zuordnen:</strong></dt>
              <dd>
                Verschiebt die Maßnahme in eine andere Gruppe oder in „ohne Zuordnung“.
              </dd>
              <dt><strong>Löschen:</strong></dt>
              <dd>
                Löscht die Maßnahme nach einer Sicherheitsabfrage.
              </dd>
            </dl>

          <h3>Auswahl für die Analyse</h3>
            <p>
              Mit den Kontrollkästchen legen Sie fest, welche Maßnahmen in die Analyse einfließen.
              Das Kontrollkästchen in der Gruppenüberschrift bezieht die gesamte Gruppe ein.
              Für Maßnahmen ohne Gruppenzuordnung erscheint ein eigenes Kontrollkästchen direkt in der
              Zeile. Über die Schaltfläche „Analyse“ oben rechts starten Sie anschließend die
              Berechnung der ausgewählten Maßnahmen.
            </p>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "ProjectDashboardHelp",
});
</script>

<style scoped>
</style>
